import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";
import Inicio from "./pages/Inicio";
import Empresa from "./pages/Empresa";
import Servicios from "./pages/Servicios";
import Instalaciones from "./pages/Instalaciones";
import Beneficios from "./pages/Beneficios";
import AyudasSubvenciones from "./pages/AyudasSubvenciones";
import CalculadoraSolar from "./pages/CalculadoraSolar";
import FAQ from "./pages/FAQ";
import Contacto from "./pages/Contacto";
import Blog from "./pages/Blog";
import BlogArticulo from "./pages/BlogArticulo";
import Ciudades from "./pages/Ciudades";
import PlacasSolaresCiudad from "./pages/seo/PlacasSolaresCiudad";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import AvisoLegal from "./pages/AvisoLegal";
import Cookies from "./pages/Cookies";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <WhatsAppButton />
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/empresa" element={<Empresa />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/instalaciones" element={<Instalaciones />} />
            <Route path="/beneficios" element={<Beneficios />} />
            <Route path="/ayudas-subvenciones" element={<AyudasSubvenciones />} />
            <Route path="/calculadora-solar" element={<CalculadoraSolar />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/ciudades" element={<Ciudades />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticulo />} />
            <Route path="/placas-solares/:ciudad" element={<PlacasSolaresCiudad />} />
            <Route path="/instalar-placas-solares/:ciudad" element={<PlacasSolaresCiudad />} />
            <Route path="/empresa-placas-solares/:ciudad" element={<PlacasSolaresCiudad />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
